export class ApprovalRequest {
    name: string;
    raw: any;
    type: string = "ApprovalRequest";    
    approval: any;

    constructor(init?: any){
        if (init) {
            this.initialize(init);
        }
    }

    initialize(item: any) {
        if (item.properties) {
            // via run-api
            //this._id = this.name = item.name;
            // this.flowName = item.properties.object.flowName;
            this.name = item.name;
            this.raw = item;
            return;
        }
    }

    get approvalCreationDate():Date {
        return this.raw.properties.approval.properties.creationDate ? new Date(this.raw.properties.approval.properties.creationDate): null;
    }

    get approvalDetails(): string {
        return this.raw.properties.approval.properties.details;
    }

    get approvalItemLink(): string {
        return this.raw.properties.approval.properties.itemLink;
    }

    get approvalItemDescription(): string {
        return this.raw.properties.approval.properties.itemLinkDescription;
    }

    get approvalStatus(): string {
        return this.raw.properties.approval.properties.status;
    }

    get approvalTitle(): string {
        return this.raw.properties.approval.properties.title;
    }

    get approvalRequestUrl(): string {
        // https://australia.flow.microsoft.com/manage/environments/Default-26e65220-5561-46ef-9783-ce5f20489241/approvals/received/c60b2417-5eb7-41c8-9493-6167b0538d99/requests/d9fa7c04-4a1d-442a-a4e4-800fb1f90ff9?response=NotSpecified
        return `/approvals/received/${this.raw.properties.approval.name}/requests/${this.name}?response=NotSpecified`;
    }

    get flowUrl(): string {
        // /flows/shared/9e00ea27-9f05-4e3b-a86e-3f12ae9d9235/details
        if (!this.raw.properties.approval.properties.flowId) {
            return null;
        }
        return `/flows/${this.raw.properties.approval.properties.flowId}/details`;
    }

    get approvalOwner(): string {
        return this.raw.properties.approval.properties.owner.displayName;
    }

    get approvers(): any[] {
        return (this.approval && this.approval.properties.requestSummary) ? this.approval.properties.requestSummary.approvers: null;
    }

    // get duration(){
    //     return this.endTime ? this.endTime.getTime() - this.startTime.getTime() : null;
    // }

    // get durationString() {
    //     var diff = this.duration;
    //     var days = Math.floor(diff / (1000 * 60 * 60 * 24));
    //     diff -=  days * (1000 * 60 * 60 * 24);
        
    //     var hours = Math.floor(diff / (1000 * 60 * 60));
    //     diff -= hours * (1000 * 60 * 60);
        
    //     var mins = Math.floor(diff / (1000 * 60));
    //     diff -= mins * (1000 * 60);
        
    //     var seconds = diff/1000;// Math.floor(diff / (1000));
    //     //diff -= seconds * (1000);

    //     var results = [];
    //     if (days) results.push(`${days}d`);
    //     if (hours) results.push(`${hours}h`);
    //     if (mins) results.push(`${mins}m`);
    //     if (seconds) results.push(`${seconds}s`);
    //     //if (diff) results.push(`${diff}ms`);
    //     return results.join(' ');
    //     //document.write(days + " days, " + hours + " hours, " + mins + " minutes, " + seconds + " seconds");        
    // }

    get actions() : string[] {
        var actions = [];
        //actions.push(...this.raw.properties.responseOptions );
        actions.push('Cancel');
        actions.push('Export Excel');
        return actions;
    }

}